import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AgenticInsightsApi } from '@/features/agentic-insights/api/agenticInsightsApi';
import type { Persona } from './types';

const PERSONAS_QUERY_KEY = ['loop-agentic-insights', 'personas'];

/**
 * The org's configured roles, empty when it has never configured any.
 *
 * Deliberately not wired to the run's mock/real data-source toggle: roles are org configuration
 * stored in the DB, not sample output. Serving the built-in defaults here in mock mode made every
 * save look like it had been discarded, because the refetch handed the hard-coded set straight
 * back over whatever had just been written.
 */
export const usePersonasQuery = () =>
  useQuery<Persona[]>({
    queryKey: PERSONAS_QUERY_KEY,
    queryFn: () => AgenticInsightsApi.getPersonas(),
  });

export const useSavePersonasMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (personas: Persona[]) => AgenticInsightsApi.savePersonas(personas),
    onSuccess: (saved) => {
      queryClient.setQueryData(PERSONAS_QUERY_KEY, saved);
    },
  });
};
